export class Partenza {
    IDPartenza: number;
    ContactID: number;
    Giorno: number;
    Mese: number;
    Anno: number;
    Ore: number;
    Minuti: number;
    IDPercorso: number;
    Posti: number;
    Prezzo: number;
    PrezzoGolfcar: number;
    PrezzoCarrello: number;
    PrezzoCarrelloElettrico: number;
    PrezzoSacca: number;
    Created: Date | null;
    CreatedBy: string;
    ScontoGreenFee: number;
    ScontoGolfcar: number;
    PrezzoHotel: number;
    // campi ausiliari
    Disp: number;
    Percorso: string;
    Riservata: boolean;
    Nomi: string;
    Prenotabile: boolean;

    constructor() {
        this.IDPartenza = 0;
        this.ContactID = 0;
        this.Giorno = 0;
        this.Mese = 0;
        this.Anno = 0;
        this.Ore = 0;
        this.Minuti = 0;
        this.IDPercorso = 0;
        this.Posti = 0;
        this.Prezzo = 0;
        this.PrezzoGolfcar = 0;
        this.PrezzoCarrello = 0;
        this.PrezzoCarrelloElettrico = 0;
        this.PrezzoSacca = 0;
        this.Created = null;
        this.CreatedBy = '';
        this.ScontoGreenFee = 0;
        this.ScontoGolfcar = 0;
        this.PrezzoHotel = 0;
        // campi ausiliari
        this.Disp = 0;
        this.Percorso = '';
        this.Riservata = false;
        this.Nomi = '';
        this.Prenotabile = true;
    }
}

export class GetPartenzeReq {
    data: string; // ISO format
    store: string; // golfclub
    myToken: string; // giocatore / socio
    percorso: number;

    constructor() {
        this.data = '';
        this.store = '';
        this.myToken = '';
        this.percorso = 0;
    }
}
export class GetPartenzeResp {
    error: string;
    partenze: Partenza[] | null;
    dispGolfcar: number;
    dispCarrelli: number;
    dispCarrelliEl: number;
    dispSacche: number;
    isSocio: boolean;

    constructor() {
        this.error = '';
        this.partenze = null;
        this.dispGolfcar = 0;
        this.dispCarrelli = 0;
        this.dispCarrelliEl = 0;
        this.dispSacche = 0;
        this.isSocio = false;
    }
}

export class Percorso
{
    id: number;
    descr: string;
}

export class GetPercorsiResp
{
    error: string;
    percorsi: Percorso[] | null;
    isSocio: boolean;

    constructor() {
        this.error = '';
        this.percorsi = null;
        this.isSocio = false;
    }
}

export class GetPartenzaReq {
    store: string;
    myToken: string;
    partenzaId: number;

    constructor() {
        this.store = '';
        this.myToken = '';
        this.partenzaId = 0;
    }
}

export class GetPartenzaResp {
    error: string;
    partenza: Partenza | null;
    disp: number;
    dispGolfcar: number;
    dispCarrelli: number;
    dispCarrelliEl: number;
    dispSacche: number;

    constructor() {
        this.error = '';
        this.partenza = null;
        this.disp = 0;
        this.dispGolfcar = 0;
        this.dispCarrelli = 0;
        this.dispCarrelliEl = 0;
        this.dispSacche = 0;
       }
}